export function digitsOnly(value) {
  return String(value ?? '').replace(/\D/g, '');
}

// DNI: 8 dígitos (sin puntos ni guiones)
export function formatDni(value) {
  return digitsOnly(value).slice(0, 8);
}

// CUIL/CUIT: 11 dígitos, formato XX-XXXXXXXX-X
export function formatCuil(value) {
  const digits = digitsOnly(value).slice(0, 11);
  if (digits.length <= 2) return digits;
  if (digits.length <= 10) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  return `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10)}`;
}

